<template lang="pug">
  .modal-mask.column.center.middle
    button.close-button.self-end(type='button' @click='closeModal')
      img(:src='closeIcon' alt='close')
    .video(v-html='videoHtml' v-on-clickaway='closeModal')
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

import closeIcon from '@/assets/ic_cross.svg'
import { getOEmbedHtml, getOEmbedUrl } from '../../utils/embed'

export default {
  data() {
    return {
      closeIcon,
      videoHtml: null
    }
  },
  props: {
    videoUrl: { type: String, required: true }
  },
  async created() {
    const oembedUrl = getOEmbedUrl(this.videoUrl)
    const html = await getOEmbedHtml(oembedUrl)
    this.videoHtml = html
  },
  methods: {
    closeModal() {
      this.$emit('close')
    }
  },
  mixins: [ clickaway ]
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $black-translusent;
  display: flex;
  transition: opacity .3s ease;
  z-index: 80;
}

.video {
  height: 664px;
  width: 1180px;
  border: 0;
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;

  img {
    filter: invert(1);
    width: 25px;
    height: 25px;
  }
}
</style>
